import * as ACTION_TYPES from './ACTION_TYPES';
import * as COLORS from './colors';
import * as PAGINATION from './PAGINATION';
import * as CART_KEY from './CART_KEY';
import * as VIEWS from './VIEWS';
import * as ANALYTICS from './ANALYTICS';
import * as LEGACY_DATA_PAGE from './LEGACY_DATA_PAGE';
import * as PLANS from './PLANS';
import * as TRADES from './TRADES';
import * as URL from './URL';
import COUNTRIES from './countriesData';

// TODO: import inline all the above like this.
enum BUY_SHOP_ITEM_STATE {
  DEFAULT = 1,
  NOT_EXISTS,
  SUCCESS,
  CLIENT_ERROR,
  SERVER_ERROR,
  INSUFFICIENT_CREDITS,
  NO_BT_ACCOUNT,
  PAYMENT_FAILURE,
  NO_GOLD_ACCOUNT,
  FETCHING,
}

// TODO: refactor BUY_SHOP_ITEM_STATE
export namespace STATE {
  export enum FAVOURITE {
    DEFAULT = 1,
    IS_FETCHING,
    NO_BT_ACCOUNT,
    NO_GOLD_ACCOUNT,
    SERVER_ERROR,
    IS_FETCHING_GRAPH,
    USER_FAVOURITE_TAG,
    NOT_FOUND,
  }
  export enum FREE_TRIAL {
    DEFAULT,
    SHOW_FREE_TRIAL,
    SERVER_ERROR,
  }
}

const MY_DATA_PAGE_TAB = {
  REPORTS: 'reports',
  PRICES: 'prices',
};

export type CartItemDataType = DataItem | ShopItem | ShopItemCategory;
export type CartItemType = 'dataItem' | 'shopItem' | 'shopItemCategory';

export const PIWIK_SITES = {
  11: 'AATRI',
  10: 'KENKO',
  9: 'DASHBOARD_STAGING',
  8: 'DASHBOARD',
  7: 'WEB',
  6: 'WEB_STAGING',
  5: 'MOBILE',
  4: 'MOBILE_STAGING',
};

export {
  ACTION_TYPES,
  ANALYTICS,
  COLORS,
  PAGINATION,
  CART_KEY,
  VIEWS,
  LEGACY_DATA_PAGE,
  PLANS,
  TRADES,
  URL,
  COUNTRIES,
  BUY_SHOP_ITEM_STATE,
  MY_DATA_PAGE_TAB,
};



// WEBPACK FOOTER //
// ./app/constants/index.ts